import "./AboutMe.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import UberUns from "./sections/UberUns";
import BilderReihe from "./sections/BilderReihe";
import OurServices from "./sections/OurServices";
import HeroSection from "./sections/HeroSection";
import ProjectInquiry from "./sections/ProjectInquiry";
import Footer from "@/reusable_sections/Footer";
export default function AboutMePage() {
  return <div>
      <Header />
      <Hero />
      <UberUns />
      <BilderReihe />
      <OurServices />
      <HeroSection />
      <ProjectInquiry />
      <Footer />
    </div>;
}